import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';
import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const campaignsSlice = createAppSlice({
  name: 'campaigns',
  initialState,
  reducers,
});

export default campaignsSlice.reducer;

export const {
  loadCampaigns,
  createCampaign,
  deleteCampaign,
  addLocalCampaign,
  loadFavoriteTemplates,
  addFavoriteTemplate,
  removeFavoriteTemplate,
  loadRecentTemplates,
  addRecentTemplate,
} = campaignsSlice.actions;
